import Repository from "../repositories/RepositoryFactory";
const PatientRepository = Repository.get("patients");
export default {
  data() {
    return {
      patients: [],
    };
  },
  created: async function() {

},
  methods: {
    async getItems(event) {

      const query = event.target.value.toLowerCase();

      if (query.length > 2)
      {
        const result = await PatientRepository.filterPatients(query);
        this.patients = [];
        this.patients = result.data;
      // eslint-disable-next-line no-console
      console.log(this.patients);        
      }
      else 
      {
        this.patients = [];          
      }
    },
  },
};
